import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import { Observable } from "rxjs";
import { API_HEADERS } from "./api-headers";
import { environment } from "../../environments/environment";

export function authTokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const piaOrigin = environment.pia.apiOrigin;
  const piaToken = environment.pia.apiToken;
  if (piaToken && piaOrigin && req.url.startsWith(piaOrigin)) {
    return next(
      req.clone({
        setHeaders: { [API_HEADERS.authorization]: `Bearer ${piaToken}` },
      }),
    );
  }

  const baseUrl = environment.api.baseUrl;
  if (!baseUrl || !req.url.startsWith(baseUrl)) {
    return next(req);
  }

  const tokens = inject(OKTA_AUTH).tokenManager.getTokensSync();
  const accessToken = tokens.accessToken?.accessToken;

  if (!accessToken) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { [API_HEADERS.authorization]: `Bearer ${accessToken}` },
    }),
  );
}
